var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('tr',[_vm._t("thead")],2)]),_c('tbody',_vm._l((_vm.data),function(instance){return _c('tr',{key:instance.id},[_vm._t("default",null,{instance:instance})],2)}))])}
var staticRenderFns = []

export { render, staticRenderFns }